import { Component, computed, input, model, output, signal } from '@angular/core';

@Component({
  selector: 'app-icourrier-checkable-list',
  templateUrl: './checkable-list.component.html',
  styleUrl: './checkable-list.component.scss',
})
export class CheckableListComponent<T extends object> {
  public readonly items = model.required<T[]>();
  public readonly loading = input<boolean>(false);
  /**
   * @description
   * The label of the items in the list.
   * Can be a simple 'label' key or an array of keys to merge into string format.
   * @example
   * ['name', 'surname'] => `${item.name} ${item.surname}`
   *
   *
   * @default 'label'
   */
  public readonly itemLabel = input<string | string[]>('label');
  public readonly withSearch = input<boolean>(true);

  public readonly onCheck = output<T[]>();

  public readonly search = signal<string>('');
  public readonly filteredCheckableItems = computed(() =>
    this.items().filter((item) => this.getItemLabel(item).toLowerCase().includes(this.search().toLowerCase().trim()))
  );

  public emit(): void {
    const checkedItems = this.items().filter((item) => (item as T & { checked: boolean }).checked);

    this.onCheck.emit(checkedItems);
  }

  public onCheckElement(item: T & { checked: boolean }): void {
    const checkableItems = this.items();
    const index = checkableItems.findIndex((checkableItem) => checkableItem['id'] === item['id']);

    if (index < 0) return;

    checkableItems[index] = item;
    this.items.set([...checkableItems]);
    this.emit();
  }

  public getItemLabel(item: T): string {
    const itemLabel = this.itemLabel();

    if (Array.isArray(itemLabel)) {
      let label = '';

      for (const labelKey of itemLabel) {
        label += `${item[labelKey] ?? ''} `;
      }

      label = label.trimEnd();

      return label;
    }

    return itemLabel === 'label' ? (item['label'] ?? '') : ((item[itemLabel] as string) ?? '');
  }
}
